// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"502":"ucare-panel-chunk","868":"ucare-widget-chunk"}[chunkId] || chunkId) + "." + {"502":"d2a7cf0d","596":"e03a2010","868":"05cfc8a2"}[chunkId] + ".js";
};